import React from 'react'
import {Field} from "react-final-form";

// resources
import { narrowDown } from '~/data/shop/itemSearchOption'

// components
import RenderCheckBox from '~/components/finalForms/atoms/RenderCheckBox'
import {css} from "@emotion/react";

export const ItemSubCategoryField = React.memo(( ) => {
  return(
      <div>
        <div>
          <Field
              id="itemSubCategory"
              name="itemSubCategory"
              labels={narrowDown.itemSubCategories.map((category) => category.label)}
              vals={narrowDown.itemSubCategories.map((category) => category.code)}
              component={RenderCheckBox}
              css={checkboxStyle}
          />
        </div>
      </div>
  )
})

ItemSubCategoryField.displayName = 'ItemSubCategoryField'

const checkboxStyle = css`
  width: 11rem;
  span:first-of-type {
    padding: 0.5rem 0.5rem 0.5rem 1rem;
  }
  span:last-of-type {
    padding: 0.5rem 0;
    font-size: 1.4rem;
  }
`